import Slider from "@kamae-apps/shared/old/Component/Input/Slider"
import { FC } from "react"
import { CompanyData } from "../../Companies"

type SwitchCalendarTypeSectionProps = {
  company: CompanyData
  onCalendarTypeChange: (e: any) => void
}

export const CalendarTypeSection: FC<SwitchCalendarTypeSectionProps> = ({ company, onCalendarTypeChange }) => {
  return (
    <div className={"flex flex-col gap-2"}>
      <h3 className={"mb-2 w-full text-center text-lg"}>Calendrier</h3>
      <div className={"flex w-full justify-start gap-2"}>
        <Slider
          id={"companyHasCalendarCenteredCollaboratorEnabled"}
          checked={company.user_centric_calendar}
          onChange={onCalendarTypeChange}
          className={"m-1"}
        />
        <label
          htmlFor={"companyHasCalendarCenteredCollaboratorEnabled"}
          className={"flex grow items-center justify-between"}
        >
          <span className={"mr-2"}>Centré collaborateur</span>
        </label>
      </div>
    </div>
  )
}
